import {auth, store} from '@/store'
import {AccessorWrapper} from '@simpli/vuex-typescript'
import {AuthState, RootState} from '@/types/store'

export const wrapper = new AccessorWrapper<AuthState, RootState>('auth')

export abstract class Auth {
  static $accessors = wrapper.accessors

  static get token() {
    return Auth.$accessors.read(auth.getters.token)(store)
  }

  static get isLogged() {
    return Auth.$accessors.read(auth.getters.isLogged)(store)
  }

  static get global() {
    return Auth.$accessors.read(auth.getters.global)(store)
  }

  static signIn(payload: {code: string; state: string}) {
    return Auth.$accessors.dispatch(auth.actions.signIn)(store, payload)
  }

  static authenticate() {
    return Auth.$accessors.dispatch(auth.actions.authenticate)(store)
  }

  static signOut() {
    return Auth.$accessors.dispatch(auth.actions.signOut)(store)
  }

  static loadGlobal() {
    return Auth.$accessors.dispatch(auth.actions.loadGlobal)(store)
  }
}
